// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import { LotteryKind } from "./data/LotteryKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class LotteryItemBase extends BaseComponent {


	@property({ type: cc.Node, displayName:'' })
	judgeNode: cc.Node = null;

    /** 是否已刮开 */
    protected bOpenShow = false;
    // onLoad () {}

    checkJudge( pos : cc.Vec2 , pos2 : cc.Vec2 ){
        if (this.bOpenShow) {
            return true;
        }

        let count = 0;
        let children = this.judgeNode.children;
        for(let i = children.length-1; i >= 0; i--) {
            let nodeItem = children[i];
            if (nodeItem.active) {
                if (cc.Intersection.lineRect( pos , pos2 , nodeItem.getBoundingBoxToWorld())) {
                    nodeItem.active = false;
                } else {
                    count++;
                }
            }
        }

        if (count <= 0) {
            this.bOpenShow = true;
        }

        this.judgeOpenFinish();
        return this.bOpenShow;
    }

    isOpenShow() {
        return this.bOpenShow;
    }

    /**
     * 检查是否过了 判断点
     * @param pos
     * @private
     */
    checkJudgeNode ( pos : cc.Vec2 ) {
        if (this.bOpenShow) {
            return true;
        }

        // let circleSize = LotteryKind.GeneralValue.EVERY_CIRCLE_ADJUST + 1;
        let circleSize = LotteryKind.GeneralValue.SINGLE_TOUCH_CIRCLE;
        
        let rect = cc.rect( pos.x - circleSize, pos.y - circleSize, circleSize*2, circleSize*2);
        let children = this.judgeNode.children;

        let count = 0;
        for(let i = children.length-1; i >= 0; i--) {
            let nodeItem = children[i];
            if (nodeItem.active) {
                let box = nodeItem.getBoundingBoxToWorld();
                if (rect.intersects(box)) {
                    // childLen--;
                    // nodeItem.destroy();
                    nodeItem.active = false;
                    // this.sprBg.node.color = cc.Color.YELLOW;
                } else {
                    count++;
                }
            }
        }

        if (count <= 0) {
            this.bOpenShow = true;

            // // 测试代码
            // this.sprBg.node.color = cc.Color.RED;
        }
        this.judgeOpenFinish();
        return this.bOpenShow;
    }

    judgeOpenFinish() {
        if (this.bOpenShow) {

        }
    }

    // update (dt) {}
}
